import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import { usePageContent } from "@/i18n/pageContent";

function ListSection({ eyebrow, titleA, titleB, image, list, bg, reverse }) {
  return (
    <section className={`${bg} py-20 md:py-28`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className={`lg:col-span-6 reveal ${reverse ? "lg:order-2" : ""}`}>
          <div className="zoom-wrap aspect-[4/3] w-full">
            <img src={image} alt={eyebrow} loading="lazy" className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="lg:col-span-6 reveal delay-1">
          <span className="eyebrow">{eyebrow}</span>
          <h2 className="font-display text-3xl md:text-5xl text-[#1a365d] mt-5 leading-[1.08] tracking-tight">
            {titleA} <span className="italic">{titleB}</span>.
          </h2>
          <ul className="mt-7 space-y-3">
            {list.map((row) => (
              <li key={row} className="flex items-start gap-3 border-b border-[#e2e8f0] pb-3 font-body text-[15px] text-[#1e293b]">
                <span className="text-[#d4af37] mt-1 font-display">·</span>
                <span>{row}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default function Events() {
  const c = usePageContent("events");
  return (
    <PageShell>
      <PageHero
        eyebrow={c.eyebrow}
        title={<>{c.titleA} <span className="italic">{c.titleB}</span>.</>}
        subtitle={c.subtitle}
        image="/events-hero.jpg"
      />
      <ListSection eyebrow={c.s1Eyebrow} titleA={c.s1Title1} titleB={c.s1Title2}
        image="/networking-inclusion.jpg"
        list={c.engaged} bg="bg-white" />
      <ListSection eyebrow={c.s2Eyebrow} titleA={c.s2Title1} titleB={c.s2Title2}
        image="/eventi-national.jpg"
        list={c.platforms} bg="bg-[#fafaf7]" reverse />
      <ListSection eyebrow={c.s3Eyebrow} titleA={c.s3Title1} titleB={c.s3Title2}
        image="/eventi-crafts.jpg"
        list={c.fairs} bg="bg-white" />
      <ListSection eyebrow={c.s4Eyebrow} titleA={c.s4Title1} titleB={c.s4Title2}
        image="/eventi-intl.jpg"
        list={c.international} bg="bg-[#fafaf7]" reverse />
    </PageShell>
  );
}
